import { FC } from "react";
// 组件
import { ReloadOutlined } from "@ant-design/icons";
import { ProTooltip } from "../../../antd";
import CopyTableData from '../../../CopyTableData';
import HelpLink from "../../../SuperTable/subpage/helpLink";
// 常量
import { ToolbarProps, toolBarType } from "../../interface";

const Toolbar: FC<ToolbarProps> = props => {
  const { toolBar, headOperation, showHelpIcon, dataSource, copyColumns, onRefresh, } = props;
  /** toolbar操作按钮 */
  const renderOperation = (item: toolBarType) => {
    switch (item) {
      case 'refresh':
        return (
          <ProTooltip placement="top" title="刷新" key={item}>
            <ReloadOutlined onClick={() => onRefresh?.()} />
          </ProTooltip>
        );
      case 'copy':
        return (
          <ProTooltip placement="top" title="复制" key={item}>
            <CopyTableData
              dataSource={dataSource}
              copyColumns={copyColumns}
            />
          </ProTooltip>
        );
      default:
        return null;
    }
  };

  return (
    <div className="card-table-toolbar">
      <div className="card-table-toolbar-left">{headOperation}</div>
      {
        toolBar !== false && (
          <div className="card-table-toolbar-right">
            {
              showHelpIcon && <HelpLink key='help-link' />
            }
            {Array.isArray(toolBar) &&
              toolBar.map(item => (
                <span className="card-table-toolbar-right-icon" key={item}>
                  {renderOperation(item)}
                </span>
              ))}
          </div>
        )
      }
    </div>
  );
};

export default Toolbar;
